<script setup>
import { computed, getCurrentInstance } from 'vue';
import { isDateInFuture } from '@tools/date';
import { trans } from '@elements/translation';

const props = defineProps({
  offer: {
    type: Object,
    required: true,
  },
});

const newLabelDuration = getCurrentInstance().appContext.config.globalProperties.$newLabelDuration * 1000;
const availableDate = computed(() => props.offer.availability_date.iso);
const show = computed(() => isDateInFuture(availableDate.value, Math.floor(Date.now() - newLabelDuration)));
</script>

<template>
  <span v-if="show" class="hit-label hit-label--proposal_new">
    {{ trans('offer_card.labels.proposal_new') }}
  </span>
</template>
